import React from "react";
import GhostCom from "./GhostCom";

function App() {
  return <GhostCom />;
}

export default App;